import { useMatch } from "react-router-dom";
import { listAndDetailSamplesRoutes, listAndDetailSamplesRoutesCombined } from "../../ListAndDetailSamplesNavigation";
import { ListAndDetailSampleEditForm } from "../ListAndDetailSampleEditForm";

export const ListAndDetailSamplesBasicEditPage = () => {

    const match = useMatch(listAndDetailSamplesRoutesCombined.basic_editMatch);
    const cityTownCode = match?.params.cityTownCode;

    return (
        <ListAndDetailSampleEditForm
            listUrl={listAndDetailSamplesRoutes.basic}
            cityTownCode={cityTownCode}
        />
    )
}
